import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "007_remove_payment_allocation_header_fk",
  version: "1.4.3",
  ignoreErrors: [
    "no such table: accounting_payment_allocations",
  ],
  sql: `
DROP TABLE IF EXISTS \`accounting_payment_allocations_new\`;

CREATE TABLE \`accounting_payment_allocations_new\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`payment_id\` text NOT NULL,
  \`invoice_id\` text NOT NULL,
  \`allocated_amount\` real NOT NULL,
  \`allocation_date\` text,
  \`allocation_type\` text NOT NULL DEFAULT 'invoice',
  \`status\` text NOT NULL DEFAULT 'active',
  \`gl_source_id\` text,
  \`reversal_of\` text,
  \`reversed_at\` text,
  \`reversed_by\` text,
  \`reversal_reason\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text,
  \`updated_by\` text
);

INSERT INTO \`accounting_payment_allocations_new\` (
  \`id\`,
  \`payment_id\`,
  \`invoice_id\`,
  \`allocated_amount\`,
  \`allocation_date\`,
  \`allocation_type\`,
  \`status\`,
  \`gl_source_id\`,
  \`reversal_of\`,
  \`reversed_at\`,
  \`reversed_by\`,
  \`reversal_reason\`,
  \`created_at\`,
  \`created_by\`,
  \`updated_at\`,
  \`updated_by\`
)
SELECT
  \`id\`,
  \`payment_id\`,
  \`invoice_id\`,
  \`allocated_amount\`,
  \`allocation_date\`,
  \`allocation_type\`,
  \`status\`,
  \`gl_source_id\`,
  \`reversal_of\`,
  \`reversed_at\`,
  \`reversed_by\`,
  \`reversal_reason\`,
  \`created_at\`,
  \`created_by\`,
  \`updated_at\`,
  \`updated_by\`
FROM \`accounting_payment_allocations\`;

DROP TABLE \`accounting_payment_allocations\`;

ALTER TABLE \`accounting_payment_allocations_new\`
RENAME TO \`accounting_payment_allocations\`;

CREATE INDEX IF NOT EXISTS \`pay_alloc_payment_status_idx\`
  ON \`accounting_payment_allocations\` (\`payment_id\`, \`status\`);

CREATE INDEX IF NOT EXISTS \`pay_alloc_invoice_status_idx\`
  ON \`accounting_payment_allocations\` (\`invoice_id\`, \`status\`);
  `.trim(),
};
